import { useSelector } from "react-redux";

export const useClientData = () => {
  const { anonymityInfo, isLoading } = useSelector(state => state.client);
  return { anonymityInfo, isLoading };
};
